import { Bookinghub } from '../../index';

import type { CabinPresentRequest } from '../../generated/bookinghub';
import type { ApiStatefulResponse } from '../../utils/api-result';

type OrderCabinPresentsResponse = ApiStatefulResponse;

export async function orderCabinPresents(
  request: CabinPresentRequest,
): Promise<OrderCabinPresentsResponse> {
  const { data, error, response } = await Bookinghub.postCabinpresents({
    body: {
      ...request,
    },
  });

  // Note: 1.7.0 spec swapped CabinPresent response types — POST returns success object as CabinPresentResponse
  if ((data as any)?.success) {
    return { success: true };
  }

  if (error?.message) {
    return { success: false, errorMessage: error.message };
  }

  if (error && response.statusText.includes('Timeout')) {
    return { success: false, errorMessage: 'timeout' };
  }

  return {
    success: false,
    errorMessage:
      data && 'message' in data && typeof data.message === 'string'
        ? data.message
        : 'Unknown error',
  };
}
